/**
 * Audit Utilities for Frontend
 * Captures device and browser information for security logging.
 */

export const getDeviceInfo = () => {
    const ua = navigator.userAgent;
    let browser = "Unknown";
    let os = "Unknown";
    let device = "Desktop";

    // Simple Browser Detection
    if (ua.includes("Firefox")) browser = "Firefox";
    else if (ua.includes("Chrome")) browser = "Chrome";
    else if (ua.includes("Safari") && !ua.includes("Chrome")) browser = "Safari";
    else if (ua.includes("Edge")) browser = "Edge";

    // Simple OS Detection
    if (ua.includes("Win")) os = "Windows";
    else if (ua.includes("Mac")) os = "MacOS";
    else if (ua.includes("Linux")) os = "Linux";
    else if (ua.includes("Android")) { os = "Android"; device = "Mobile"; }
    else if (ua.includes("iPhone")) { os = "iOS"; device = "Mobile"; }

    return {
        browser,
        os,
        device,
        userAgent: ua,
        timestamp: new Date().toISOString()
    };
};
